import * as React from 'react';
import visualisationMap from '../visualisations';
import { Alert } from 'antd';
import injectSheet from 'react-jss';
import Loader from '../Loader';
import ChartPlaceholderIcon from '../icons/ChartPlaceholderIcon';
const styles = (theme: any) => ({
  parentContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  placeholderIcon: {
    fontSize: 128,
  },
  placeholderLabel: {
    color: '#565656',
    paddingTop: 12,
    fontSize: 16,
    fontWeight: 600,
  },
});
class Chart extends React.PureComponent<any, any> {
  render() {
    const { formData, chartData, isChartLoading, error, width, height, classes,
      isInsightsChart } = this.props;
    if (error) {
      return <Alert message={error} type="error" />;
    }
    const visType = this.props.visType || formData.visualisation_type;
    const VisComponent = visualisationMap[visType];
    if (!VisComponent || ((!chartData || !chartData.length) && !error && !isChartLoading)) {
      return <div className={classes.parentContainer} style={{ width, height }}>
        <div><ChartPlaceholderIcon className={classes.placeholderIcon}></ChartPlaceholderIcon></div>
        <div className={classes.placeholderLabel}>
          {
            isInsightsChart ? 'No Data' : 'Create a new visualization'
          }</div>
      </div>;
    }

    if (isChartLoading) {
      return (
        <Loader zIndex={1} />
      );
    }

    if (error) {
      return <Alert message={error} type="error" />;
    }

    return <VisComponent
      labelStringX={this.props.labelStringX}
      labelStringY={this.props.labelStringY}
      formData={formData}
      chartData={chartData}
      onClick={this.props.onClick}
      width={width}
      height={height}
    />;
  }
}

export default injectSheet(styles)(Chart);
